var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWelcome = function SvgWelcome(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 131,
    viewBox: "0 0 145 131",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M0 60.1974L22.092 73.0412L44.3233 60.2766L22.092 47.4296L0 60.1974Z",
    fill: "#031FEF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M32.0053 65.2513L30.3979 66.176L54.7966 80.0901L56.4072 79.1655L32.0053 65.2513Z",
    fill: "#031FEF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M36.704 90.8439L71.1426 110.87L105.796 90.9706L71.1426 70.948L36.704 90.8439Z",
    fill: "#031FEF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M100.673 118.153L122.765 131L144.997 118.235L122.765 105.388L100.673 118.153Z",
    fill: "#031FEF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M91.0704 98.5831L89.4598 99.5078L113.862 113.422L115.469 112.497L91.0704 98.5831Z",
    fill: "#031FEF"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.79
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "M22.2755 50.3431V25.2602L44.01 12.7014L44.1967 12.7806V37.6006L44.0512 37.8507L22.4337 50.3431H22.2755Z",
    fill: "url(#paint0_linear_2844:11055)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "M0.502181 12.6095L0.476868 12.6602L22.2367 25.2696L44.0376 12.752L44.0281 12.505L22.3822 0H22.0943L0.511673 12.5018L0.502181 12.6095Z",
    fill: "url(#paint1_linear_2844:11055)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "M22.2755 25.2601V50.343H22.1173L0.496696 37.8506L0.354309 37.6005V12.7773L0.436577 12.6823L0.468218 12.6602L22.2755 25.2601Z",
    fill: "url(#paint2_linear_2844:11055)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M22.1395 45.8022V25.2445L39.9568 14.9498L40.1055 14.9023V35.3587L39.9885 35.5646L22.2693 45.8022H22.1395Z",
    fill: "url(#paint3_linear_2844:11055)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M4.29302 14.8732L4.27087 14.9144L22.1103 25.2534L39.9782 14.9904L39.9687 14.7909L22.2274 4.54053H21.9901L4.29935 14.7877L4.29302 14.8732Z",
    fill: "url(#paint4_linear_2844:11055)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M22.1395 25.2444V45.8022H22.0098L4.29059 35.5645L4.17035 35.3586V14.8611L4.23363 14.8674L4.26527 14.9181L22.1395 25.2444Z",
    fill: "url(#paint5_linear_2844:11055)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M22.1114 4.65498L39.8306 14.8927L22.1114 25.067L4.49347 14.861L22.1114 4.65498ZM4.17389 14.861L22.1114 25.2507L40.0964 14.9243C40.1091 14.918 40.1154 14.9053 40.1154 14.8927C40.1154 14.88 40.1091 14.8673 40.0964 14.861L22.1114 4.47131L4.17389 14.861Z",
    fill: "url(#paint6_linear_2844:11055)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.1141 50.343H22.4337V25.352L44.1935 12.7805L44.029 12.505L22.1141 25.1683V50.343Z",
    fill: "url(#paint7_linear_2844:11055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.513305 12.5018L0.353516 12.7788L22.1952 25.3994L22.355 25.1224L0.513305 12.5018Z",
    fill: "#394CF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1953 29.1202L32.5879 30.0449L59.8312 45.8653L61.4417 44.9407L34.1953 29.1202Z",
    fill: "url(#paint8_linear_2844:11055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5844 31.9006L32.5875 30.0449L59.8308 45.8654L59.8276 47.7242L32.5844 31.9006Z",
    fill: "url(#paint9_linear_2844:11055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1742 86.3727V54.2441L99.0155 38.1577L99.2528 38.0817V70.0519L99.0693 70.3717L71.3767 86.3727H71.1742Z",
    fill: "url(#paint10_linear_2844:11055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2854 38.0405L43.2506 38.1038L71.1267 54.2568L99.0534 38.2242L99.0376 37.9075L71.3134 21.8876H70.9432L43.2981 37.9012L43.2854 38.0405Z",
    fill: "url(#paint11_linear_2844:11055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1742 54.2442V86.3728H70.9717L43.2759 70.3718L43.0924 70.052V38.0184L43.1905 38.0279L43.2411 38.1039L71.1742 54.2442Z",
    fill: "url(#paint12_linear_2844:11055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1271 22.0681L98.8165 38.069L71.1271 53.9686L43.5927 38.0183L71.1271 22.0681ZM71.1271 21.7799L43.0959 38.0183L71.1271 54.2568L99.231 38.1197C99.2469 38.1102 99.2595 38.0912 99.2595 38.0722C99.2595 38.0532 99.25 38.0342 99.231 38.0247L71.1271 21.7799Z",
    fill: "url(#paint13_linear_2844:11055)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.79
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "M71.2057 93.4692V54.2696L105.176 34.6396L105.464 34.7663V73.5575L105.239 73.9469L71.4526 93.4692H71.2057Z",
    fill: "url(#paint14_linear_2844:11055)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "M37.1818 34.4972L37.1407 34.5763L71.1521 54.2854L105.22 34.722L105.201 34.3388L71.3767 14.7944H70.9242L37.1945 34.3293L37.1818 34.4972Z",
    fill: "url(#paint15_linear_2844:11055)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "M71.2058 54.2695V93.4691H70.959L37.1723 73.9469L36.9476 73.5574V34.7631L37.0774 34.6111L37.128 34.5795L71.2058 54.2695Z",
    fill: "url(#paint16_linear_2844:11055)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M70.9559 93.4692H71.4558V54.4121L105.461 34.7632L105.201 34.3389L70.9559 54.1239V93.4692Z",
    fill: "url(#paint17_linear_2844:11055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0824 54.4849L71.3292 54.0542L37.1976 34.3325L36.9476 34.7632L71.0824 54.4849Z",
    fill: "url(#paint18_linear_2844:11055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4821 66.8063L92.3043 64.5992V60.2134L88.4821 62.4205V66.8063Z",
    fill: "url(#paint19_linear_2844:11055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0708 62.1829L89.4602 63.1075L104.98 72.0722L106.588 71.1476L91.0708 62.1829Z",
    fill: "url(#paint20_linear_2844:11055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4567 64.9632L89.4598 63.1075L104.98 72.0722L104.974 73.9279L89.4567 64.9632Z",
    fill: "url(#paint21_linear_2844:11055)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.79
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "M123.079 107.466V82.3828L144.813 69.8208L145 69.9031V94.7231L144.854 94.9733L123.237 107.466H123.079Z",
    fill: "url(#paint22_linear_2844:11055)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "M101.305 69.7323L101.28 69.7798L123.043 82.3924L144.841 69.8748L144.831 69.6278L123.186 57.1228H122.898L101.315 69.6246L101.305 69.7323Z",
    fill: "url(#paint23_linear_2844:11055)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "M123.079 82.383V107.466H122.921L101.3 94.9734L101.158 94.7233V69.9001L101.24 69.802L101.271 69.783L123.079 82.383Z",
    fill: "url(#paint24_linear_2844:11055)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M122.943 102.925V82.3671L140.76 72.0724L140.912 72.0249V92.4813L140.792 92.6871L123.072 102.925H122.943Z",
    fill: "url(#paint25_linear_2844:11055)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M105.096 71.9959L105.074 72.0371L122.914 82.3729L140.781 72.1131L140.772 71.9136L123.031 61.66H122.793L105.103 71.9072L105.096 71.9959Z",
    fill: "url(#paint26_linear_2844:11055)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M122.943 82.367V102.925H122.813L105.094 92.687L104.974 92.4812V71.9836L105.037 71.99L105.068 72.0375L122.943 82.367Z",
    fill: "url(#paint27_linear_2844:11055)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M122.915 61.7776L140.634 72.0153L122.915 82.1897L105.297 71.9837L122.915 61.7776ZM104.977 71.9837L122.915 82.3734L140.9 72.047C140.912 72.0407 140.919 72.028 140.919 72.0153C140.919 72.0027 140.912 71.99 140.9 71.9837L122.915 61.5908L104.977 71.9837Z",
    fill: "url(#paint28_linear_2844:11055)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M122.917 107.466H123.237V82.4748L144.997 69.9001L144.832 69.6278L122.917 82.2911V107.466Z",
    fill: "url(#paint29_linear_2844:11055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.318 69.6312L101.158 69.9082L123 82.5287L123.16 82.2518L101.318 69.6312Z",
    fill: "#394CF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.631 78.8142L107.249 78.0131V78.5387L108.631 79.3367V78.8142Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.726 80.0238L110.267 79.7578V80.2835L110.726 80.5463V80.0238Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.577 81.094L111.422 80.4259V80.9516L112.577 81.6165V81.094Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.707 79.4349L109.251 79.1721V79.6946L109.707 79.9606V79.4349Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.555 79.4475L110.777 78.9946V79.5203L111.555 79.9699V79.4475Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.226 77.522L107.249 76.9584V77.4809L108.226 78.0477V77.522Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.255 78.6937L109.799 78.4309V78.9565L110.255 79.2194V78.6937Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.239 78.1078L108.783 77.8418V78.3675L109.239 78.6303V78.1078Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.776 79.0929L111.59 78.4089V78.9346L112.776 79.6186V79.0929Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.036 76.9332L107.249 75.9009V76.4265L109.036 77.4589V76.9332Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.068 78.1081L110.612 77.8452V78.3677L111.068 78.6337V78.1081Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.052 77.5189L109.593 77.2561V77.7818L110.052 78.0446V77.5189Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.052 87.4208L107.252 86.9617V87.5L108.052 87.9623V87.4208Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.21 88.6685L109.739 88.3961V88.9376L110.21 89.21V88.6685Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.539 90.0144L110.928 89.0865V89.6249L112.539 90.5559V90.0144Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.16 88.0635L108.691 87.7911V88.3326L109.16 88.605V88.0635Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.324 88.8018L111.308 88.2159V88.7574L112.324 89.3433V88.8018Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.679 86.6959L107.252 85.8726V86.4109L108.679 87.2374V86.6959Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.773 87.9054L110.302 87.6331V88.1746L110.773 88.4469V87.9054Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.723 87.3008L109.252 87.0284V87.5668L109.723 87.8391V87.3008Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.159 88.1967L110.891 86.8826V87.4241L113.159 88.735V88.1967Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.261 85.3627L107.252 84.7832V85.3215L108.261 85.9042V85.3627Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.353 86.5724L109.881 86.3V86.8415L110.353 87.1139V86.5724Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.305 85.9674L108.834 85.6951V86.2366L109.305 86.5089V85.9674Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.448 83.2698L107.23 82.5668V83.1083L108.448 83.8113V83.2698Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.606 84.5173L110.134 84.245V84.7865L110.606 85.0588V84.5173Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.305 85.4992L111.324 84.9324V85.4739L112.305 86.0407V85.4992Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.558 83.9125L109.087 83.6401V84.1785L109.558 84.4508V83.9125Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.555 85.1316L111.913 84.1848V84.7231L113.555 85.6731V85.1316Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.283 82.6649L107.23 81.4774V82.0189L109.283 83.2064V82.6649Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.378 83.8746L110.906 83.6023V84.1438L111.378 84.4161V83.8746Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.33 83.2666L109.859 82.9943V83.5358L110.33 83.8081V83.2666Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.346 83.922L111.495 82.8517V83.3932L113.346 84.4635V83.922Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.865 81.3317L107.23 80.3881V80.9296L108.865 81.8732V81.3317Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.96 82.5414L110.489 82.269V82.8105L110.96 83.0829V82.5414Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.91 81.9365L109.438 81.6642V82.2057L109.91 82.478V81.9365Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7533 48.6521L45.5922 47.4044V48.2214L47.7533 49.4722V48.6521Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.025 50.5425L50.3099 50.1309V50.951L51.025 51.3627V50.5425Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9202 52.2147L52.1166 51.1729V51.993L53.9202 53.0348V52.2147Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4366 49.6243L48.7215 49.2126V50.0328L49.4366 50.4445V49.6243Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3223 49.643L51.1041 48.9369V49.757L52.3223 50.4632V49.643Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1173 46.6348L45.5922 45.7513V46.5715L47.1173 47.455V46.6348Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2909 48.4683L49.5758 48.0535V48.8736L50.2909 49.2884V48.4683Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7025 47.55L47.9874 47.1351V47.9553L48.7025 48.3701V47.55Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2271 49.0922L52.3729 48.0187V48.8388L54.2271 49.9123V49.0922Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3859 45.7165L45.5919 44.1016V44.9217L48.3859 46.5367V45.7165Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5598 47.5501L50.8447 47.1384V47.9586L51.5598 48.3702V47.5501Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9713 46.6318L49.2562 46.2201V47.0402L49.9713 47.4519V46.6318Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8451 62.107L45.5984 61.385V62.2305L46.8451 62.9525V62.107Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2181 64.0543L49.484 63.63V64.4755L50.2181 64.8998V64.0543Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.86 66.1571L51.3445 64.7036V65.5491L53.86 67.0026V66.1571Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5791 63.1076L47.845 62.6832V63.5287L48.5791 63.953V63.1076Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5214 64.26L51.9362 63.3448V64.1903L53.5214 65.1055V64.26Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.826 60.97L45.5984 59.6812V60.5266L47.826 61.8155V60.97Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0977 62.8605L50.3605 62.4362V63.2816L51.0977 63.706V62.8605Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4587 61.9137L48.7246 61.4894V62.3349L49.4587 62.7592V61.9137Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8314 63.3132L51.2812 61.2644V62.1099L54.8314 64.1587V63.3132Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.171 58.8897L45.5984 57.9808V58.8263L47.171 59.7351V58.8897Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4428 60.7802L49.7087 60.3558V61.2013L50.4428 61.6257V60.7802Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8037 59.8333L48.0696 59.4089V60.2544L48.8037 60.6787V59.8333Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4621 55.6155L45.5605 54.5167V55.3622L47.4621 56.461V55.6155Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8383 57.566L50.101 57.1417V57.9872L50.8383 58.4115V57.566Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4962 59.102L51.9615 58.2153V59.0608L53.4962 59.9475V59.102Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1993 56.6193L48.462 56.1949V57.0404L49.1993 57.4648V56.6193Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4484 58.5287L52.8823 57.0436V57.8891L55.4484 59.3742V58.5287Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7721 54.6688L45.5605 52.8163V53.6618L48.7721 55.5142V54.6688Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0438 56.5592L51.3066 56.1349V56.9804L52.0438 57.4047V56.5592Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4048 55.6124L49.6675 55.1881V56.0336L50.4048 56.4579V55.6124Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1225 56.6352L52.2273 54.9633V55.8087L55.1225 57.4807V56.6352Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1171 52.5882L45.5605 51.1125V51.958L48.1171 53.4337V52.5882Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3889 54.4786L50.6548 54.0543V54.8998L51.3889 55.3241V54.4786Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7498 53.5317L49.0157 53.1074V53.9529L49.7498 54.3772V53.5317Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.55277 21.3432L6.17004 20.5452V21.0708L7.55277 21.8688V21.3432Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.64747 22.556L9.19183 22.29V22.8157L9.64747 23.0785V22.556Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5016 23.6263L10.3467 22.9581V23.4838L11.5016 24.1488V23.6263Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.63171 21.9669L8.17291 21.7041V22.2266L8.63171 22.4926V21.9669Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4796 21.9796L9.69806 21.5267V22.0524L10.4796 22.5021V21.9796Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.14776 20.0543L6.17004 19.4874V20.0131L7.14776 20.5767V20.0543Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.17914 21.2258L8.72034 20.963V21.4887L9.17914 21.7515V21.2258Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.16029 20.64L7.70465 20.374V20.8997L8.16029 21.1625V20.64Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6978 21.6249L10.5113 20.9409V21.4634L11.6978 22.1506V21.6249Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.96089 19.4653L6.16998 18.433V18.9555L7.96089 19.991V19.4653Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.98915 20.6401L9.53351 20.3741V20.8998L9.98915 21.1626V20.6401Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.97346 20.0512L8.51782 19.7883V20.3108L8.97346 20.5768V20.0512Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.97376 29.953L6.17639 29.4907V30.0322L6.97376 30.4945V29.953Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.13168 31.2007L8.66022 30.9283V31.4698L9.13168 31.7422V31.2007Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4605 32.5466L9.85309 31.6156V32.1571L11.4605 33.0881V32.5466Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.08437 30.5959L7.61292 30.3236V30.8651L8.08437 31.1374V30.5959Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2453 31.3337L10.2296 30.7479V31.2863L11.2453 31.8721V31.3337Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.60026 29.228L6.17639 28.4015V28.943L7.60026 29.7663V29.228Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.69497 30.4377L9.22351 30.1654V30.7069L9.69497 30.9761V30.4377Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.6476 29.8296L8.17615 29.5573V30.0987L8.6476 30.3711V29.8296Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0838 30.7258L9.81195 29.4148V29.9563L12.0838 31.2673V30.7258Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.18259 27.8948L6.17639 27.3121V27.8536L7.18259 28.4363V27.8948Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.27724 29.1044L8.80579 28.832V29.3735L9.27724 29.6459V29.1044Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.22671 28.4996L7.75525 28.2273V28.7688L8.22671 29.0411V28.4996Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.36926 25.8016L6.15106 25.0986V25.6401L7.36926 26.3431V25.8016Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.52718 27.0492L9.05573 26.7769V27.3183L9.52718 27.5907V27.0492Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2295 28.0311L10.2486 27.4642V28.0057L11.2295 28.5726V28.0311Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.47988 26.4413L8.00842 26.1689V26.7104L8.47988 26.9828V26.4413Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4793 27.6636L10.8372 26.7136V27.2551L12.4793 28.2051V27.6636Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.20775 25.1968L6.15106 24.0093V24.5508L8.20775 25.7351V25.1968Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2993 26.4065L9.82782 26.1342V26.6725L10.2993 26.9448V26.4065Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.25191 25.7985L8.78046 25.5261V26.0676L9.25191 26.3399V25.7985Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2705 26.454L10.4163 25.3837V25.9252L12.2705 26.9955V26.454Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.78692 23.8637L6.15106 22.92V23.4615L7.78692 24.4052V23.8637Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.88162 25.0732L9.41016 24.8009V25.3424L9.88162 25.6147V25.0732Z",
    fill: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.83109 24.4685L8.36279 24.1962V24.7377L8.83109 25.01V24.4685Z",
    fill: "#CCFFFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2844:11055",
    x1: 47.3557,
    y1: 23.5475,
    x2: 10.2685,
    y2: 44.4393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00362319,
    stopColor: "#3766FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2072,
    stopColor: "#2D8AF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5805,
    stopColor: "#1BC6DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8554,
    stopColor: "#10ECCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0CFACA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2844:11055",
    x1: 26.2982,
    y1: 9.10844,
    x2: -8.28489,
    y2: 39.3045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00362319,
    stopColor: "#3766FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2072,
    stopColor: "#2D8AF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5805,
    stopColor: "#1BC6DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8554,
    stopColor: "#10ECCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0CFACA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2844:11055",
    x1: -15.3211,
    y1: 23.075,
    x2: 41.4648,
    y2: 41.0271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00362319,
    stopColor: "#3766FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2072,
    stopColor: "#2D8AF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5805,
    stopColor: "#1BC6DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8554,
    stopColor: "#10ECCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0CFACA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2844:11055",
    x1: 39.3315,
    y1: 25.7392,
    x2: 13.4039,
    y2: 40.3446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#031FEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#031FEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2844:11055",
    x1: 6.99425,
    y1: 24.6588,
    x2: 35.7829,
    y2: 6.11677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#031FEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#031FEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2844:11055",
    x1: -31.8773,
    y1: 16.0872,
    x2: 29.7463,
    y2: 35.5686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#031FEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#031FEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2844:11055",
    x1: 6.46248,
    y1: 23.9345,
    x2: 30.6596,
    y2: 9.97631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#031FEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#031FEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2844:11055",
    x1: 44.1931,
    y1: 31.4247,
    x2: 22.1152,
    y2: 31.4247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4872FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8478,
    stopColor: "#394CF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2844:11055",
    x1: 46.7054,
    y1: 38.1162,
    x2: 34.8042,
    y2: 62.0806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00362319,
    stopColor: "#48CAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.064,
    stopColor: "#46C1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#3985FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8294,
    stopColor: "#305FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D51FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2844:11055",
    x1: 40.8071,
    y1: 63.6196,
    x2: 48.2553,
    y2: 29.5586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00362319,
    stopColor: "#48CAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2496,
    stopColor: "#40A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5874,
    stopColor: "#3678FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8488,
    stopColor: "#2F5BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D51FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2844:11055",
    x1: 98.0409,
    y1: 55.0176,
    x2: 57.5218,
    y2: 77.8427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00362319,
    stopColor: "#48CAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.064,
    stopColor: "#46C1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#3985FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8294,
    stopColor: "#305FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D51FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2844:11055",
    x1: 47.5059,
    y1: 53.3302,
    x2: 92.4963,
    y2: 24.3531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00362319,
    stopColor: "#48CAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3F3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2844:11055",
    x1: -13.2429,
    y1: 39.9339,
    x2: 83.0612,
    y2: 70.379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00362319,
    stopColor: "#48CAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2496,
    stopColor: "#40A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5874,
    stopColor: "#3678FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8488,
    stopColor: "#2F5BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D51FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2844:11055",
    x1: 46.6737,
    y1: 52.1976,
    x2: 84.4886,
    y2: 30.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00362319,
    stopColor: "#48CAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3F3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2844:11055",
    x1: 103.912,
    y1: 55.2548,
    x2: 45.9523,
    y2: 87.9042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00362319,
    stopColor: "#48CAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.064,
    stopColor: "#46C1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#3985FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8294,
    stopColor: "#305FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D51FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2844:11055",
    x1: 42.3314,
    y1: 53.1542,
    x2: 97.2215,
    y2: 17.8009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00362319,
    stopColor: "#48CAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3F3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2844:11055",
    x1: -31.6062,
    y1: 36.9043,
    x2: 85.6863,
    y2: 73.9846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00362319,
    stopColor: "#48CAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2496,
    stopColor: "#40A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5874,
    stopColor: "#3678FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8488,
    stopColor: "#2F5BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D51FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2844:11055",
    x1: 88.7333,
    y1: 81.9338,
    x2: 87.8629,
    y2: 52.4269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#56ABFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#52B3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3441,
    stopColor: "#4BC4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5328,
    stopColor: "#48CAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCFFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2844:11055",
    x1: 23.5717,
    y1: 25.0152,
    x2: 70.0531,
    y2: 54.458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48CAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCFFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2844:11055",
    x1: 97.774,
    y1: 56.0831,
    x2: 81.7843,
    y2: 60.5518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00362319,
    stopColor: "#48CAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1775,
    stopColor: "#42B0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4674,
    stopColor: "#3987FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5908,
    stopColor: "#3677FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8497,
    stopColor: "#2F5BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D51FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2844:11055",
    x1: 97.7951,
    y1: 67.5899,
    x2: 88.955,
    y2: 85.3905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00362319,
    stopColor: "#48CAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.064,
    stopColor: "#46C1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#3985FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8294,
    stopColor: "#305FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D51FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2844:11055",
    x1: 93.7948,
    y1: 84.1959,
    x2: 98.5157,
    y2: 62.6072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00362319,
    stopColor: "#48CAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2496,
    stopColor: "#40A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5874,
    stopColor: "#3678FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8488,
    stopColor: "#2F5BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D51FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2844:11055",
    x1: 148.159,
    y1: 80.6692,
    x2: 111.072,
    y2: 101.561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00362319,
    stopColor: "#3766FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2072,
    stopColor: "#2D8AF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5805,
    stopColor: "#1BC6DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8554,
    stopColor: "#10ECCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0CFACA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2844:11055",
    x1: 127.102,
    y1: 66.2304,
    x2: 92.5186,
    y2: 96.4266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00362319,
    stopColor: "#3766FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2072,
    stopColor: "#2D8AF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5805,
    stopColor: "#1BC6DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8554,
    stopColor: "#10ECCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0CFACA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2844:11055",
    x1: 85.4823,
    y1: 80.1971,
    x2: 142.268,
    y2: 98.1491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00362319,
    stopColor: "#3766FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2072,
    stopColor: "#2D8AF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5805,
    stopColor: "#1BC6DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8554,
    stopColor: "#10ECCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0CFACA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2844:11055",
    x1: 140.135,
    y1: 82.861,
    x2: 114.207,
    y2: 97.4664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#031FEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#031FEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2844:11055",
    x1: 107.798,
    y1: 81.7807,
    x2: 136.586,
    y2: 63.2387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#031FEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#031FEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2844:11055",
    x1: 68.926,
    y1: 73.209,
    x2: 130.55,
    y2: 92.6904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#031FEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#031FEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2844:11055",
    x1: 107.266,
    y1: 81.0564,
    x2: 131.463,
    y2: 67.0982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#031FEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#031FEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2844:11055",
    x1: 144.997,
    y1: 88.5468,
    x2: 122.919,
    y2: 88.5468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4872FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8478,
    stopColor: "#394CF6"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWelcome, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/welcome.70654e2a.svg";
export { ForwardRef as ReactComponent };